var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _g4, _g5, _rect, _g6, _g7, _rect2, _g8, _g9, _rect3, _g10, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 41,
    viewBox: "0 0 140 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7731 30.5746L35.9647 36.3543C36.5893 36.6504 37.3372 36.3857 37.6114 35.7511C40.4609 29.1581 42.2289 19.8782 39.0666 12.7396C36.088 6.01593 28.7221 4.18935 26.1144 4.57146L21.3303 7.16305C23.1408 7.49529 26.7917 9.7546 26.9113 16.1339C27.0102 21.4128 24.8869 26.0547 23.2573 28.591C22.8178 29.2752 23.0382 30.2262 23.7731 30.5746Z",
    fill: "#2B80D7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_757_4400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 4,
    width: 20,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7729 30.5756L35.9646 36.3553C36.5892 36.6514 37.337 36.3867 37.6113 35.7522C40.4608 29.1591 42.2288 19.8792 39.0664 12.7406C36.0879 6.01697 28.722 4.19039 26.1142 4.5725L21.3302 7.16409C23.1407 7.49633 26.7915 9.75564 26.9111 16.1349C27.0101 21.4139 24.8867 26.0558 23.2572 28.592C22.8176 29.2762 23.0381 30.2273 23.7729 30.5756Z",
    fill: "#DEA00D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_757_4400)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5039 32.5567C33.9273 27.9282 42.5345 9.06471 38.2167 5.33505C36.6291 3.96374 22.1396 4.28811 20.8451 3.26373L21.9001 4.83447C21.9001 4.83447 26.1423 10.1484 25.8646 18.4931C25.6941 23.6179 23.8529 28.9158 22.7088 31.5057C22.5218 31.9291 14.0223 27.7347 13.8626 28.0601C13.4086 28.9852 21.7437 33.1143 21.7437 33.1143L27.0832 32.7056C27.2364 32.6939 27.3792 32.6465 27.5039 32.5567Z",
    fill: "url(#paint0_linear_757_4400)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7585 37.5957C44.0405 32.869 49.8711 18.8297 45.4867 10.985C44.4631 9.15374 36.7988 3.91329 35.5043 2.88892L35.1019 8.10882C35.1019 8.10882 39.8324 12.6668 39.5542 21.0274C39.3361 27.5836 37.4864 32.5818 36.6982 34.4338C36.5078 34.8811 35.9986 35.0773 35.548 34.895C33.4191 34.0339 27.7723 31.7044 27.97 31.3017C27.5159 32.2268 35.7741 37.0681 35.7741 37.0681L36.8569 37.6517C37.1458 37.8074 37.4963 37.793 37.7585 37.5957Z",
    fill: "url(#paint1_linear_757_4400)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_f_757_4400)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8579,
    height: 13.2748,
    rx: 2.50252,
    transform: "matrix(0.94997 0.312342 -0.312247 0.950001 22.1003 19.6764)",
    fill: "#13497E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter3_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3471 27.4754C28.4416 23.9177 29.22 12.5756 24.8108 8.19896C23.6742 7.07075 21.978 5.85963 20.884 5.10443L21.7756 6.26242C21.7756 6.26242 25.3605 10.18 25.1259 16.3319C24.9818 20.11 23.4258 24.0158 22.459 25.9251C22.301 26.2373 15.1183 23.1451 14.9833 23.3849C14.5996 24.0669 21.6434 27.111 21.6434 27.111L22.5338 27.5297C22.7977 27.6538 23.1081 27.6423 23.3471 27.4754Z",
    fill: "#2B80D7"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7528 25.5821L21.5637 21.5322C21.2166 21.4065 20.8376 21.6059 20.7301 21.9591C19.9526 24.5153 17.913 29.1299 13.9518 30.8591C8.74258 33.1331 7.02865 28.0456 9.32083 34.4747C11.613 40.9038 19.1871 42.7478 26.1135 38.8106C31.1344 35.9565 33.0705 30.1317 33.5382 26.8385C33.6165 26.2865 33.277 25.7719 32.7528 25.5821Z",
    fill: "url(#paint2_linear_757_4400)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_757_4400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 21,
    width: 26,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7528 25.583L21.5637 21.5331C21.2166 21.4074 20.8376 21.6068 20.7301 21.96C19.9526 24.5162 17.913 29.1309 13.9518 30.8601C8.74258 33.1341 7.02865 28.0465 9.32083 34.4756C11.613 40.9047 19.1871 42.7487 26.1135 38.8115C31.1344 35.9575 33.0705 30.1326 33.5382 26.8394C33.6165 26.2874 33.277 25.7728 32.7528 25.583Z",
    fill: "url(#paint3_radial_757_4400)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_757_4400)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2951 42.5985C26.1553 42.5985 30.6981 22.9979 29.4337 19.6697C29.3657 19.4906 29.2004 19.3771 29.0175 19.3198L8.8407 12.9901L21.1183 18.0541C21.2539 18.11 21.3323 18.2507 21.3029 18.3944C21.0665 19.5502 19.9078 24.5405 16.9736 27.7074C13.6379 31.3077 6.74822 32.1155 3.9062 31.4442C2.3928 31.4418 1.53851 30.924 1.53851 30.924C4.98006 33.1604 9.92243 42.5985 15.2951 42.5985Z",
    fill: "url(#paint4_linear_757_4400)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter5_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5462 30.2266C20.9591 27.2363 24.2503 15.9094 23.3705 12.7544C23.2911 12.4698 23.016 12.3139 22.7208 12.3007L10.8992 11.7725L21.1887 16.8316C21.3106 16.8916 21.3802 17.02 21.3574 17.1539C21.1681 18.2651 20.1997 23.3015 17.7217 26.4898C14.9234 30.0901 9.1439 30.8979 6.75982 30.2266C5.49027 30.2242 4.83484 30.7384 4.83484 30.7384C7.72185 32.9748 12.6279 32.8818 16.5462 30.2266Z",
    fill: "#3EBADD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4594 39.7768C31.7735 36.7561 36.4431 24.6301 35.34 21.5639C35.2562 21.3311 35.0266 21.2051 34.7809 21.1755L20.7022 19.4763L20.3826 21.5418L31.501 25.8838C31.8647 26.0258 32.0996 26.377 32.0517 26.7644C31.8755 28.1892 31.1222 31.7713 27.9065 35.4312C23.759 40.1516 17.7629 39.928 14.9209 39.2566C13.4075 39.2543 13.035 39.2566 13.035 39.2566C16.2735 41.5583 21.7885 42.432 26.4594 39.7768Z",
    fill: "url(#paint5_linear_757_4400)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8492 19.9696C12.4608 26.3458 9.18192 39.4025 19.5466 40.8478C15.4933 41.1596 6.28127 39.0776 2.09556 29.1897C-3.13657 16.8298 7.12895 1.97807 18.5898 0.632436C29.7941 -0.683075 35.5694 5.43197 38.8951 12.3653C38.9805 12.5302 39.0554 12.69 39.1198 12.8428C39.0461 12.6832 38.9713 12.524 38.8951 12.3653C37.6154 9.89346 33.9745 6.28911 27.8084 8.6065C23.348 10.2828 18.4561 15.0642 15.8492 19.9696Z",
    fill: "#2CBBF9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_757_4400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8491 19.9692C12.4606 26.3453 9.18174 39.402 19.5464 40.8474C15.4931 41.1592 6.28108 39.0772 2.09538 29.1893C-3.13675 16.8294 7.12877 1.97764 18.5896 0.632009C29.7939 -0.683502 35.5692 5.43155 38.895 12.3649C38.9803 12.5298 39.0552 12.6896 39.1196 12.8423C39.046 12.6828 38.9711 12.5236 38.895 12.3649C37.6152 9.89304 33.9743 6.28868 27.8082 8.60607C23.3478 10.2824 18.4559 15.0638 15.8491 19.9692Z",
    fill: "#00CCC0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_757_4400)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.02797 28.9148C-3.84226 38.8027 15.196 41.7637 19.2493 41.4519C19.4527 39.5337 13.637 35.3692 13.8399 30.7351C13.8399 30.7351 6.42384 30.9726 5.29145 19.9686C4.15905 8.96457 10.47 3.42664 10.47 3.42664C2.94591 7.13621 -10.2923 23.5657 -8.02797 28.9148Z",
    fill: "url(#paint6_linear_757_4400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1197 12.8437C58.657 -2.92797 25.6051 -6.5688 14.1443 -5.22316C9.37325 -4.663 -3.17705 7.95291 1.76321 13.382C1.76321 13.382 6.88638 7.70573 14.1443 6.66871C21.4021 5.6317 24.763 10.8645 24.763 10.8645C25.6473 10.322 27.9725 10.1726 28.8441 9.84502C35.4216 7.37305 38.7982 12.166 39.1197 12.8437Z",
    fill: "url(#paint7_linear_757_4400)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57371 30.463C-9.09094 26.7788 -3.47676 1.75742 8.22628 -1.82367C18.7561 -5.04576 19.6238 0.0170327 21.476 0.325487C21.7165 0.318057 21.8468 0.322822 21.8468 0.322822C21.7173 0.345496 21.5947 0.345243 21.476 0.325487C20.0846 0.368481 15.0061 0.819809 10.163 4.96562C2.87899 11.2008 -0.0537467 21.1691 2.57371 30.463Z",
    fill: "#56E5FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4345 40.8271C18.193 44.4765 4.92489 40.039 0.739182 30.1511C-0.0144128 28.3708 0.804953 22.9092 0.750505 20.7866C0.741019 20.6274 0.739182 20.5422 0.739182 20.5422C0.744548 20.6177 0.748266 20.6993 0.750505 20.7866C0.820913 21.9686 1.31272 27.2278 4.60258 31.9806C8.3357 37.3738 16.0037 39.4862 16.0037 39.4862C17.0043 40.198 19.8307 40.6035 21.4345 40.8271Z",
    fill: "#FDC7C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_757_4400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: 19,
    width: 27,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.6031,
    height: 9.34097,
    transform: "matrix(0.696245 0.717804 -0.717687 0.696365 1.69708 19.1935)",
    fill: "url(#paint8_linear_757_4400)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4351 40.8266C18.1936 44.476 4.9255 40.0385 0.739792 30.1506C-0.0138025 28.3704 0.805563 22.9087 0.751115 20.7862C0.741629 20.6269 0.739792 20.5417 0.739792 20.5417C0.745158 20.6172 0.748876 20.6989 0.751115 20.7862C0.821524 21.9681 1.31333 27.2273 4.60319 31.9801C8.33631 37.3733 16.0043 39.4857 16.0043 39.4857C17.0049 40.1975 19.8314 40.603 21.4351 40.8266Z",
    fill: "#FDC7C7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9479 13.3626C40.8016 7.15892 29.7346 -2.45468 18.2737 -1.10905C14.1272 -0.622203 10.4532 3.37355 7.297 6.63861C7.297 6.63861 14.46 0.272333 23.1801 1.49707C31.9002 2.7218 35.7964 9.17948 35.7964 9.17948C37.6173 10.2445 38.4481 13.5172 39.9479 13.3626Z",
    fill: "#EFC7FD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_757_4400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: -3,
    width: 34,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.6276,
    height: 10.6225,
    transform: "matrix(0.989125 0.147079 -0.147031 0.989132 7.51373 -2.28931)",
    fill: "url(#paint9_linear_757_4400)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9483 13.364C40.8019 7.16032 29.735 -2.45328 18.2741 -1.10765C14.1276 -0.620799 10.4536 3.37496 7.29736 6.64001C7.29736 6.64001 14.4603 0.273737 23.1804 1.49847C31.9006 2.7232 35.7968 9.18088 35.7968 9.18088C37.6177 10.2459 38.4485 13.5186 39.9483 13.364Z",
    fill: "#EFC7FD"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6815 7.04779C14.9411 10.7507 4.54139 32.3635 14.6466 40.4706C24.7518 48.5778 36.5651 33.1777 42.5084 20.7044C39.5678 12.3218 38.4219 3.34488 26.6815 7.04779Z",
    fill: "url(#paint10_linear_757_4400)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_757_4400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -6,
    width: 51,
    height: 54
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34.2275,
    height: 40.8343,
    transform: "matrix(0.855498 0.517807 -0.51768 0.855575 16.4121 -5.47144)",
    fill: "url(#paint11_linear_757_4400)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_757_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.681 7.04736C14.9406 10.7503 4.5409 32.3631 14.6461 40.4702C24.7513 48.5773 36.5646 33.1773 42.5079 20.704C39.5674 12.3214 38.4214 3.34446 26.681 7.04736Z",
    fill: "url(#paint12_linear_757_4400)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.272 12.262C66.3318 12.0584 66.5187 11.9185 66.7309 11.9185H70.0513C70.3156 11.9185 70.5297 12.1327 70.5297 12.3969V32.0368C70.5297 32.3011 70.3156 32.5152 70.0513 32.5152H66.5503C66.3333 32.5152 66.1435 32.3692 66.0879 32.1595L65.6865 30.6463C63.9323 32.2101 61.6441 33.1255 59.0128 33.1255C52.8348 33.1255 48.2204 28.434 48.2204 22.2169C48.2204 15.9997 52.8348 11.3464 59.0128 11.3464C61.6823 11.3464 64.0085 12.3 65.8009 13.8638L66.272 12.262ZM59.4704 27.8619C62.7119 27.8619 65.0763 25.459 65.0763 22.2169C65.0763 18.9748 62.7119 16.5719 59.4704 16.5719C56.2289 16.5719 53.8645 18.9748 53.8645 22.2169C53.8645 25.4208 56.2289 27.8619 59.4704 27.8619Z",
    fill: "#E2EEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5468 12.2353C88.615 12.0453 88.7952 11.9185 88.9971 11.9185H93.7149C94.0527 11.9185 94.2841 12.2591 94.1596 12.5732L86.3777 32.2131C86.3055 32.3955 86.1292 32.5152 85.933 32.5152H81.4314C81.2369 32.5152 81.0617 32.3975 80.9883 32.2173L72.9882 12.5774C72.8601 12.2628 73.0915 11.9185 73.4313 11.9185H78.3342C78.5353 11.9185 78.7148 12.0442 78.7837 12.2331L83.7029 25.726L88.5468 12.2353Z",
    fill: "#E2EEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.703 11.9185H116.382C116.646 11.9185 116.86 12.1327 116.86 12.3969V32.0368C116.86 32.3011 116.646 32.5152 116.382 32.5152H112.881C112.664 32.5152 112.474 32.3692 112.418 32.1595L112.017 30.6463C110.263 32.2101 107.974 33.1255 105.343 33.1255C99.1651 33.1255 94.5507 28.434 94.5507 22.2169C94.5507 15.9997 99.1651 11.3464 105.343 11.3464C108.013 11.3464 110.339 12.3 112.131 13.8638L112.703 11.9185ZM105.801 27.8619C109.042 27.8619 111.407 25.459 111.407 22.2169C111.407 18.9748 109.042 16.5719 105.801 16.5719C102.559 16.5719 100.195 18.9748 100.195 22.2169C100.195 25.4208 102.559 27.8619 105.801 27.8619Z",
    fill: "#E2EEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.22 9.90083C122.734 9.90083 121.529 8.69608 121.529 7.20993C121.529 5.72379 122.734 4.51903 124.22 4.51903H124.368C125.854 4.51903 127.059 5.72379 127.059 7.20993C127.059 8.69608 125.854 9.90083 124.368 9.90083H124.22ZM121.969 32.5152C121.705 32.5152 121.491 32.3011 121.491 32.0368V12.3969C121.491 12.1327 121.705 11.9185 121.969 11.9185H126.58C126.844 11.9185 127.059 12.1327 127.059 12.3969V32.0368C127.059 32.3011 126.844 32.5152 126.58 32.5152H121.969Z",
    fill: "#E2EEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.208 25.7514C137.208 26.2368 137.308 26.5795 137.508 26.7793C137.736 26.9506 138.093 27.0363 138.578 27.0363C138.82 27.0363 139.045 27.0363 139.374 27.0363C139.703 27.0363 139.906 27.3313 139.906 27.6015V31.8765L139.906 31.896C139.906 32.2076 139.667 32.4841 139.288 32.4841C138.567 32.4841 137.969 32.5152 137.208 32.5152L136.179 32.5152C134.723 32.5152 133.596 32.1297 132.796 31.3588C132.025 30.5879 131.64 29.2173 131.64 27.2472V4.99742C131.64 4.73321 131.854 4.51903 132.118 4.51903L136.729 4.51899C136.994 4.51899 137.208 4.73317 137.208 4.99738V25.7514Z",
    fill: "#E2EEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_757_4400",
    x: 9.15251,
    y: -1.42849,
    width: 34.9215,
    height: 39.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34611,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_757_4400",
    x: 27.7955,
    y: 2.73251,
    width: 19.3744,
    height: 35.1813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0782036,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_757_4400",
    x: 14.2315,
    y: 15.9527,
    width: 26.6571,
    height: 25.0114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1897,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_757_4400",
    x: 14.3426,
    y: 4.4788,
    width: 13.9753,
    height: 23.7599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.312815,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_757_4400",
    x: -1.58963,
    y: 9.86197,
    width: 34.3573,
    height: 35.8646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.56407,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_757_4400",
    x: 4.20921,
    y: 11.1469,
    width: 19.9299,
    height: 21.8026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.312815,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_757_4400",
    x: 12.8786,
    y: 19.3199,
    width: 22.7806,
    height: 22.2482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0782036,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_757_4400",
    x: -13.29,
    y: -10.4851,
    width: 63.4633,
    height: 56.964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.50252,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_757_4400",
    x: -4.47969,
    y: -3.51784,
    width: 26.9522,
    height: 34.6065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.312815,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_757_4400",
    x: -0.206867,
    y: 19.9165,
    width: 22.2669,
    height: 22.8034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.312815,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_757_4400",
    x: 6.67137,
    y: -1.86214,
    width: 33.9486,
    height: 15.8557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.312815,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_757_4400",
    x: 10.4031,
    y: 6.03341,
    width: 32.2617,
    height: 36.8508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0782036,
    result: "effect1_foregroundBlur_757_4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_757_4400",
    x1: 29.8273,
    y1: 8.30816,
    x2: 29.6291,
    y2: 33.2823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13497E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640419,
    stopColor: "#2B80D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_757_4400",
    x1: 37.4826,
    y1: 10.1441,
    x2: 37.4921,
    y2: 36.0913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2C7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450702,
    stopColor: "#77B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_757_4400",
    x1: 27.1068,
    y1: 16.8106,
    x2: 13.7177,
    y2: 39.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269EBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EBADD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_757_4400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9325 24.3405) rotate(139.705) scale(28.4118 20.9361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411461,
    stopColor: "#FF7360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#630513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_757_4400",
    x1: 24.3926,
    y1: 22.6611,
    x2: 13.3811,
    y2: 38.3744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B6D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142991,
    stopColor: "#5BD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228AA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_757_4400",
    x1: 27.9932,
    y1: 24.3898,
    x2: 18.5455,
    y2: 40.1056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#68DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C8CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_757_4400",
    x1: 2.1872,
    y1: 13.772,
    x2: 12.5991,
    y2: 39.5353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661495,
    stopColor: "#88FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_757_4400",
    x1: 7.71764,
    y1: 15.361,
    x2: 36.6421,
    y2: 3.37058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.731633,
    stopColor: "#4D89FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_757_4400",
    x1: 25.405,
    y1: 4.54557,
    x2: 10.7951,
    y2: 7.1192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658857,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_757_4400",
    x1: 31.6064,
    y1: 7.99669,
    x2: 16.7665,
    y2: 1.09312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_757_4400",
    x1: 34.1456,
    y1: 6.96059,
    x2: 14.6812,
    y2: 39.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#2CBBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#2CBBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_757_4400",
    x1: 33.4852,
    y1: 19.1239,
    x2: 4.9907,
    y2: 18.5219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659264,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_757_4400",
    x1: 34.1451,
    y1: 6.96016,
    x2: 14.6807,
    y2: 39.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2CBBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#2CBBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC8C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailLogoFull);
export default __webpack_public_path__ + "static/media/avail-logo-full.dfcddfb926667ee64fc358ac880fc5fa.svg";
export { ForwardRef as ReactComponent };